<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <img class="modal-icon" style="width: 35px;" src="assets/ico/budget-white.svg" alt="icon">
                    <span class="modal-title" id="modal-basic-title">
                        <span> {{ 'order.budget.actionRequired' | translate }} </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body" [innerHTML]="'order.budget.creationQuestion' | translate">
    </div>
    <div class="modal-footer">
        <button type="button" class="btn modal-btn" (click)="close(false)">NO</button>
        <button type="button" class="btn modal-btn" (click)="close(true)">YES</button>
      </div>
</div>